/**
 * WHETHER THE HTML EDITORS ARE DRAWN. One constant, and it is the whole switch.
 *
 * The block builder is the only email editor now. The decision was "just don't render,
 * don't delete", and that is exactly what this is: every component, import and util
 * behind the HTML surfaces is still here and still works, and the surfaces simply have
 * no way in from the screen.
 *
 * WHY IT IS A FLAG AND NOT A DELETION. This project has twice been rescued by reversible
 * code. If a converted template turns out to hold something the blocks cannot express,
 * the escape hatch has to come back in one line — this line — rather than in a revert of
 * a commit that tore five files apart. Flip it to `true` and the Full HTML panel, the
 * cell panels, the per-cell HTML editor and the inspector's "Edit as HTML" are all back,
 * unchanged.
 *
 * WHAT IT WOULD HAVE COST TO DO THIS EARLIER, measured rather than assumed: of the 204
 * text blocks in the 79 block-authored templates, only 99 could be held by the rich text
 * editor. Hiding the hatch then would have left more than half the copy read-only. The
 * two causes — <b>/<i>, and copy with no block element around it — were fixed first, and
 * all 204 are editable now. The number is what makes this safe; nothing else does.
 *
 * WHAT IS NOT GATED, deliberately: the Preview iframe, which is the only thing on the
 * screen that shows what the SERVER will send; the plate switcher, revisions, test send
 * and clone; the conversion review, which is how an HTML template becomes a block one;
 * and the read-only "Generated HTML" fold, which states a fact about the document rather
 * than offering to edit it.
 */

// eslint-disable-next-line import/prefer-default-export
export const RENDER_HTML_EDITORS = false;
